<script setup>
import BrandWordmark from "./BrandWordmark.vue";
import LanguageSwitcher from "./LanguageSwitcher.vue";
import { useIsMobile} from "../shared/utilities";

const { isMobile } = useIsMobile();

defineProps({
  currentLang: {
    type: String,
    required: true,
  },
  langLabel: {
    type: Function,
    required: true,
  },
  hasUtrField: {
    type: Boolean,
    default: false,
  },
  supportedLangs: {
    type: Array,
    required: true,
  },
  t: {
    type: Function,
    required: true,
  },
});

console.log({
  width: window.innerWidth,
  touch: navigator.maxTouchPoints,
  ua: navigator.userAgent,
});

defineEmits(["select-language"]);
</script>

<template>
  <header class="hero grid-full" role="banner">
    <div class="hero-blobs" aria-hidden="true">
      <i class="hb1"></i>
      <i class="hb2"></i>
      <i class="hb3"></i>
    </div>

    <div class="hero-bar">
      <div class="hero-bar-brand">
        <BrandWordmark />
      </div>

      <LanguageSwitcher
        :supported-langs="supportedLangs"
        :current-lang="currentLang"
        :lang-label="langLabel"
        @select="$emit('select-language', $event)"
      />
    </div>
    <div v-if="!isMobile" class="hero-inner">
      <h1 class="hero-title">{{ t("heroTitle") }}</h1>

      <div class="hero-steps" aria-label="Payment steps">
        <span class="hero-step">
          <span class="hero-step-num" aria-hidden="true">1</span>
          <span>{{ t("step1") }}</span>
        </span>
        <span class="hero-step-arrow" aria-hidden="true">→</span>
        <span class="hero-step">
          <span class="hero-step-num" aria-hidden="true">2</span>
          <span>{{ t("step2") }}</span>
        </span>
        <span v-if="hasUtrField" class="hero-step-arrow" aria-hidden="true"
          >→</span
        >
        <span v-if="hasUtrField" class="hero-step">
          <span class="hero-step-num" aria-hidden="true">3</span>
          <span>{{ t("step3") }}</span>
        </span>
      </div>
    </div>
  </header>
</template>
